export default __webpack_public_path__ + "static/media/Girdle of Jagged Barbs.8d97fff4.jpg";